<template>
  <div class="next-gen-article">
    <div id="headerPlaceholder"></div>
    <div class="article__header">
      <div class="article__container article__header--container">
        <router-link :to="{ name: 'articles-list' }"
                     class="article__header--button">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-left" class="svg-inline--fa fa-arrow-left fa-w-14"
               role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path fill="currentColor" d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4
              44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24
              24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"></path>
          </svg>
          Back
        </router-link>
        <div class="article__header--actions">
          <button class="blue-border-btn" @click="publishArticle(entity.status, true, false)">Preview</button>
          <button class="light-blue-btn" @click="publishArticle(0)">Save as Draft</button>
          <button class="dark-blue-btn" @click="publishArticle(1)">Publish</button>
          <button class="gray-border-btn" @click="goToAllArticles()">Exit without saving</button>
        </div>
      </div>
    </div>
    <div class="article__content">
      <div class="article__container">
        <div class="article__content--title">
          <h1>Add article</h1>
        </div>
        <div class="article__content--editor">
          <div class="article__content--box">
            <div class="article__content--box__head" :class="[{ 'active': articleEditBoxActive }]">
              <div class="article__content--box__head--title">Edit article</div>
              <button class="article__content--box__head--action"
                      v-on:click="articleEditBoxActive = !articleEditBoxActive"
                      v-bind:aria-expanded="articleEditBoxActive">
                <svg xmlns="http://www.w3.org/2000/svg" width="14.096" height="8.048" viewBox="0 0 14.096 8.048">
                  <path fill="currentColor" d="M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z" transform="translate(0.048 11.031)"/>
                </svg>
              </button>
            </div>
            <div class="article__content--box__content"
                 v-bind:aria-expanded="articleEditBoxActive">
              <div class="article__form-group">
                <div class="article__form-group--sixth">
                  <div class="article__form-element">
                    <label class="article__form-label">Article content</label>
                    <Vueditor ref="contentEditor" class="form-control__editor"></Vueditor>
                  </div>
                </div>
                <div class="article__form-group--fourth">
                  <div class="article__form-element">
                    <label for="title" class="article__form-label">Title</label>
                    <input type="text" class="form-control form-control__input"
                           :class="[{ 'has-error': errors.has('Title') }]"
                           v-model="entity.title"
                           data-lpignore="true"
                           id="title"
                           v-validate="'required'"
                           data-vv-name="Title"
                           name="title">
                    <span class="form-field-error" v-if="this.errors.has('Title')">{{ this.errors.first('Title') }}</span>
                  </div>
                  <div class="article__form-element">
                    <label for="topic" class="article__form-label">Topic</label>
                    <v-select class="form-control form-control__select"
                              :searchable = true
                              :multiple="true"
                              v-model="entity.topic"
                              :options="getTagsForSelect"
                              data-vv-name="Topic"
                              data-lpignore="true"
                              :class="[{ 'has-error': errors.has('Topic') }]"
                              name="topic"
                              id="topic" />
                    <span class="form-field-error" v-if="this.errors.has('Topic')">{{ this.errors.first('Topic') }}</span>
                  </div>
                  <div class="article__form-element">
                    <label for="category" class="article__form-label">Category</label>
                    <v-select class="form-control form-control__select"
                              :searchable = true
                              :multiple="false"
                              v-model="entity.category"
                              :options="getCategoriesForSelect"
                              data-vv-name="Category"
                              data-lpignore="true"
                              :class="[{ 'has-error': errors.has('Category') }]"
                              name="category"
                              id="category" />
                    <span class="form-field-error" v-if="this.errors.has('Category')">{{ this.errors.first('Category') }}</span>
                  </div>
                  <div class="article__form-element">
                    <label for="type" class="article__form-label">Type</label>
                    <v-select class="form-control form-control__select"
                              :searchable = false
                              v-model="entity.type"
                              :options="getContentTypeForSelect"
                              data-vv-name="Type"
                              v-validate="'required'"
                              data-lpignore="true"
                              :class="[{ 'has-error': errors.has('Type') }]"
                              name="type"
                              id="type" />
                    <span class="form-field-error" v-if="this.errors.has('Type')">{{ this.errors.first('Type') }}</span>
                  </div>
                  <div class="article__form-element">
                    <div class="article__form-group">
                      <div class="article__form-element article__featured-image">
                        <span class="article__form-label">Featured image</span>
                        <label class="article__form-label article__form-label--file-upload"
                               v-show="!isThumbnailFileUploaded">
                          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="24" viewBox="0 0 32 24">
                            <path fill="currentColor" d="M29,0a3,3,0,0,0,3-3V-21a3,3,0,0,0-3-3H3a3,3,0,0,0-3,3V-3A3,3,0,0,0,3,0ZM7-20.5A3.5,3.5,0,0,1,10.5-17,3.5,3.5,0,0,1,7-13.5,3.5,3.5,0,0,1,3.5-17,3.5,3.5,0,0,1,7-20.5ZM4-4V-7l4.47-4.47a.75.75,0,0,1,1.061,0L13-8l8.47-8.47a.75.75,0,0,1,1.061,0L28-11v7Z" transform="translate(0 24)"/>
                          </svg>
                          <div class="upload-text">Upload image</div>
                          <input
                            type="file"
                            id="uploadThumbnail"
                            name="Thumbnail"
                            data-vv-as='"Thumbnail"'
                            value.sync="formInfo.thumbnail"
                            v-validate.reject="veeValidateFileUploadRules"
                            @change="onThumbnailFileChange($event)"
                            class="form-control form-control--file" />
                        </label>
                        <div id="thumbnailFilePreview" v-if="isThumbnailFileUploaded" v-bind:style="{ backgroundImage: 'url(' + featuredImage + ')' }" ></div>
                        <button
                          type="button"
                          v-if="isThumbnailFileUploaded"
                          @click="removeThumbnail"
                          class="btn btn--remove-element">
                          <span class="btn__text">-Remove image</span>
                        </button>
                      </div>
                      <div class="article__form-element">
                        <textarea class="form-control form-control__textarea has-no-label"
                                  :disabled="!isThumbnailFileUploaded"
                                  v-bind:class="{'is-blocked': !isThumbnailFileUploaded}"
                                  v-model="entity.altImage"
                                  data-lpignore="true"
                                  id="image"
                                  v-bind:placeholder="isThumbnailFileUploaded ? 'Type in Alt text for the image...' : ''"
                                  data-vv-name="Image alt"
                                  name="title"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="article__content--box__container">
            <div class="article__content--box">
              <div class="article__content--box__head" :class="[{ 'active': articleSettingsBoxActive }]">
                <div class="article__content--box__head--title">Access Settings</div>
                <button class="article__content--box__head--action"
                        v-on:click="articleSettingsBoxActive = !articleSettingsBoxActive"
                        v-bind:aria-expanded="articleSettingsBoxActive">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14.096" height="8.048" viewBox="0 0 14.096 8.048">
                    <path fill="currentColor" d="M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z" transform="translate(0.048 11.031)"/>
                  </svg>
                </button>
              </div>
              <div class="article__content--box__content"
                   v-bind:aria-expanded="articleSettingsBoxActive">
                <div class="article__form-group">
                  <div class="article__form-group--full">
                    <div class="article__form-element">
                      <label for="company-specific" class="article__form-label">Company specific</label>
                      <v-select class="form-control form-control__select"
                                :searchable = true
                                :multiple="true"
                                v-model="entity.company"
                                :options="getCompaniesForSelect"
                                :disabled="(isSpecific !== null && isSpecific === 'industry') || isExcluded !== null"
                                data-vv-name="Company specific"
                                data-lpignore="true"
                                :class="[{ 'has-error': errors.has('Company specific') }]"
                                name="company"
                                id="company-specific" />
                      <span class="form-field-error" v-if="this.errors.has('Company specific')">{{ this.errors.first('Company specific') }}</span>
                    </div>
                    <div class="article__form-element">
                      <label for="industry-specific" class="article__form-label">Industry specific</label>
                      <v-select class="form-control form-control__select"
                                :searchable = true
                                :multiple="true"
                                v-model="entity.industry"
                                :options="getIndustriesForSelect"
                                :disabled="(isSpecific !== null && isSpecific === 'company') || isExcluded !== null"
                                data-vv-name="Industry specific"
                                data-lpignore="true"
                                :class="[{ 'has-error': errors.has('Industry specific') }]"
                                name="industry"
                                id="industry-specific" />
                      <span class="form-field-error" v-if="this.errors.has('Industry specific')">{{ this.errors.first('Industry specific') }}</span>
                    </div>
                    <div class="article__form-element">
                      <label for="location-specific" class="article__form-label">Location specific</label>
                      <v-select class="form-control form-control__select"
                                :searchable = true
                                :multiple="true"
                                v-model="entity.location"
                                :options="companyLocations"
                                data-vv-name="Location specific"
                                data-lpignore="true"
                                :class="[{ 'has-error': errors.has('Location specific') }]"
                                name="location"
                                id="location-specific" />
                      <span class="form-field-error" v-if="this.errors.has('Location specific')">{{ this.errors.first('Location specific') }}</span>
                    </div>
                    <div class="article__form-element">
                      <label for="company-exclude" class="article__form-label">Exclude companies</label>
                      <v-select class="form-control form-control__select"
                                :searchable = true
                                :multiple="true"
                                :disabled="(isExcluded !== null && isExcluded === 'industry') || (isSpecific !== null && isSpecific !== 'industry')"
                                v-model="entity.notCompany"
                                :options="getCompaniesForSelect"
                                data-vv-name="Exclude companies"
                                data-lpignore="true"
                                :class="[{ 'has-error': errors.has('Exclude companies') }]"
                                name="notCompany"
                                id="company-exclude" />
                      <span class="form-field-error" v-if="this.errors.has('Exclude companies')">{{ this.errors.first('Exclude companies') }}</span>
                    </div>
                    <div class="article__form-element">
                      <label for="industry-exclude" class="article__form-label">Exclude industries</label>
                      <v-select class="form-control form-control__select"
                                :searchable = true
                                :multiple="true"
                                v-model="entity.notIndustry"
                                :disabled="(isExcluded !== null && isExcluded === 'company') || isSpecific !== null"
                                :options="getIndustriesForSelect"
                                data-vv-name="Exclude industries"
                                data-lpignore="true"
                                :class="[{ 'has-error': errors.has('Exclude industries') }]"
                                name="notIndustry"
                                id="industry-exclude" />
                      <span class="form-field-error" v-if="this.errors.has('Exclude industries')">{{ this.errors.first('Exclude industries') }}</span>
                    </div>
                    <div class="article__form-element">
                      <label for="location-exclude" class="article__form-label">Exclude locations</label>
                      <v-select class="form-control form-control__select"
                                :searchable = true
                                :multiple="true"
                                v-model="entity.notLocation"
                                :options="companyLocations"
                                data-vv-name="Exclude locations"
                                data-lpignore="true"
                                :class="[{ 'has-error': errors.has('Exclude locations') }]"
                                name="notLocation"
                                id="location-exclude" />
                      <span class="form-field-error" v-if="this.errors.has('Exclude locations')">{{ this.errors.first('Exclude locations') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="article__content--box">
              <div class="article__content--box__head" :class="[{ 'active': articleRelatedBoxActive }]">
                <div class="article__content--box__head--title">Related: resources and tasks</div>
                <button class="article__content--box__head--action"
                        v-on:click="articleRelatedBoxActive = !articleRelatedBoxActive"
                        v-bind:aria-expanded="articleRelatedBoxActive">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14.096" height="8.048" viewBox="0 0 14.096 8.048">
                    <path fill="currentColor" d="M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z" transform="translate(0.048 11.031)"/>
                  </svg>
                </button>
              </div>
              <div class="article__content--box__content"
                   v-bind:aria-expanded="articleRelatedBoxActive">
                <div class="article__form-group">
                  <div class="article__form-group--full">
                    <div class="article__form-element">
                      <label for="related-articles" class="article__form-label">Related Resources</label>
                      <v-select
                        class="form-control form-control__select"
                        :debounce="250"
                        :on-search="getOptionsThingsToConsider"
                        :options="thingsToConsiderOptions"
                        :multiple="true"
                        v-model="entity.ttc"
                        id="related-articles"
                        placeholder="Search..." />
                    </div>
                    <div class="article__form-element">
                      <label for="related-tasks" class="article__form-label">Related Tasks</label>
                      <v-select
                        class="form-control form-control__select"
                        :debounce="250"
                        :on-search="getOptionsThingsToDo"
                        :options="thingsToDoOptions"
                        :multiple="true"
                        v-model="entity.ttd"
                        id="related-tasks"
                        placeholder="Search..." />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="article__content--box" v-if="articleType.type === 'video' || articleType.type === 'document'">
            <div class="article__content--box__head" :class="[{ 'active': articleResourcesBoxActive }]">
              <div class="article__content--box__head--title">Useful resources</div>
              <button class="article__content--box__head--action"
                      v-on:click="articleResourcesBoxActive = !articleResourcesBoxActive"
                      v-bind:aria-expanded="articleResourcesBoxActive">
                <svg xmlns="http://www.w3.org/2000/svg" width="14.096" height="8.048" viewBox="0 0 14.096 8.048">
                  <path fill="currentColor" d="M.875-3.25.188-4A.665.665,0,0,1,.25-5.062l6.313-5.781a.6.6,0,0,1,.875,0L13.75-5.062A.665.665,0,0,1,13.813-4l-.687.75a.637.637,0,0,1-.5.266.672.672,0,0,1-.531-.2L7-7.875,1.906-3.187a.672.672,0,0,1-.531.2A.637.637,0,0,1,.875-3.25Z" transform="translate(0.048 11.031)"/>
                </svg>
              </button>
            </div>
            <div class="article__content--box__content"
                 v-bind:aria-expanded="articleResourcesBoxActive">
              <div class="article__form-group">
                <div class="article__form-group--sixth">
                  <div class="article__resource-row" v-for="(row, index) in entity.resources.video" v-if="articleType.type === 'video'">
                    <div class="article__form-element">
                      <label for="video-url" class="article__form-label">Video URL</label>
                      <input type="text" class="form-control form-control__input"
                             :class="[{ 'has-error': errors.has('Video URL') }]"
                             v-model="row.videoUrl"
                             data-lpignore="true"
                             id="video-url"
                             v-validate="'url'"
                             data-vv-name="Video URL"
                             name="video-url">
                      <span class="form-field-error" v-if="errors.has('Video URL')">{{ errors.first('Video URL') }}</span>
                    </div>
                    <div class="article__form-element">
                      <label for="video-transcript" class="article__form-label">Transcript for video</label>
                      <textarea type="text" class="form-control form-control__textarea"
                                v-model="row.videoTranscript"
                                data-lpignore="true"
                                id="video-transcript"
                                data-vv-name="Transcript for video"
                                name="video-transcript"></textarea>
                    </div>
                    <div class="form-element__video-remove"
                         v-if="entity.resources.video.length > 0" v-on:click="removeElement(index)">
                    </div>
                  </div>
                  <div class="article__resource-row" v-for="(row, index) in entity.resources.document" v-if="articleType.type === 'document'">
                    <div class="article__form-element">
                      <span class="article__form-label">Upload resource</span>
                      <label class="form-label">
                        <span v-if="row.resource === null" class="form-control form-control__input">+Upload resource</span>
                        <span :id="'uploadedResource_' + index" v-if="row.resource !== null" class="form-control form-control__input">{{ row.name }}</span>
                        <input
                          type="file"
                          :id="'uploadResource_' + index"
                          @change="onResourceFileChange($event, index)"
                          placeholder="Type in to add title..."
                          class="form-control visually-hidden form-control--file input-file-resource" />
                      </label>
                      <div class="form-element__video-remove"
                           v-if="entity.resources.document.length > 0" v-on:click="removeElement(index)">
                      </div>
                    </div>
                    <div class="article__form-element">
                      <label for="resource-url" class="article__form-label">Resource URL</label>
                      <input type="text" class="form-control form-control__input"
                             :class="[{ 'has-error': errors.has('Resource URL') }]"
                             v-model="row.resourceUrl"
                             data-lpignore="true"
                             id="resource-url"
                             v-validate="'url'"
                             data-vv-name="Resource URL"
                             name="resource-url">
                      <span class="form-field-error" v-if="errors.has('Resource URL')">{{ errors.first('Resource URL') }}</span>
                    </div>
                    <div class="article__form-element">
                      <label for="resource-transcript" class="article__form-label">Transcript for resource</label>
                      <textarea type="text" class="form-control form-control__textarea"
                                v-model="row.resourceTranscript"
                                data-lpignore="true"
                                id="resource-transcript"
                                data-vv-name="Transcript for video"
                                name="video-transcript"></textarea>
                    </div>
                  </div>
                  <div class="article__form-group--full form-group__video-add-button" @click="addVideoRow">
                    <div class="add-new-video">Add new</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'add-article',
    data () {
      return {
        entity: {
          title: '',
          featuredImage: '',
          altImage: '',
          type: null,
          topic: null,
          category: null,
          company: null,
          industry: null,
          location: null,
          notCompany: null,
          notIndustry: null,
          notLocation: null,
          content: '',
          ttd: [],
          ttc: [],
          loading: false,
          resources: {
            video: [
              {
                videoUrl: '',
                videoTranscript: ''
              }
            ],
            document: [
              {
                name: '',
                resource: null,
                extension: null,
                resourceUrl: '',
                resourceTranscript: ''
              }
            ]
          }
        },
        featuredImage: null,
        articleType: {
          type: null,
          shown: false
        },
        tags: [],
        categories: [],
        thingsToConsiderOptions: [],
        thingsToDoOptions: [],
        isThumbnailFileUploaded: false,
        serverValidation: {
          errors: []
        },
        disableAPI: false,
        editorToolbar: [
          [{'header': [2, 3, 4, 5, 6, false]}],
          ['bold', 'italic', 'underline', 'strike', {'color': []}, {'background': []}],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [{'indent': '-1'}, {'indent': '+1'}],
          ['blockquote', 'code-block', 'image', 'link'],
          [{'font': []}],
          [{'align': []}],
          ['clean']
        ],
        isSpecific: null,
        isExcluded: null,
        articleEditBoxActive: true,
        articleRelatedBoxActive: true,
        articleSettingsBoxActive: true,
        articleResourcesBoxActive: true
      }
    },
    computed: {
      ...mapGetters([
        'types',
        'getTagsForSelect',
        'getCategoriesForSelect',
        'getCompaniesForSelect',
        'getContentTypeForSelect',
        'getIndustriesForSelect',
        'companyLocations'
      ]),
      veeValidateFileUploadRules () {
        return {
          required: false,
          mimes: 'image/*'
        }
      },
      thingsToConsiderOptionsComputed () {
        return this.thingsToConsiderOptions
      }
    },
    watch: {
      'entity.company' (value) {
        if (value.length > 0) {
          if (this.isSpecific === null) {
            this.isSpecific = 'company'
          }
        } else {
          this.isSpecific = null
        }
      },
      'entity.industry' (value) {
        if (value.length > 0) {
          if (this.isSpecific === null) {
            this.isSpecific = 'industry'
          }
        } else {
          this.isSpecific = null
        }
      },
      'entity.notCompany' (value) {
        if (value.length > 0) {
          if (this.isExcluded === null) {
            this.isExcluded = 'company'
            this.isSpecific = null
          }
        } else {
          this.isExcluded = null
        }
      },
      'entity.notIndustry' (value) {
        if (value.length > 0) {
          if (this.isExcluded === null) {
            this.isExcluded = 'industry'
            this.isSpecific = null
          }
        } else {
          this.isExcluded = null
        }
      },
      'entity.type' (value) {
        this.entity.resources = {
          video: [
            {
              videoUrl: '',
              videoTranscript: ''
            }
          ],
          document: [
            {
              name: '',
              resource: null,
              extension: null,
              resourceUrl: '',
              resourceTranscript: ''
            }
          ]
        }
        if (value) {
          this.articleType.shown = true
          if (value.label === 'Video') {
            this.articleType.type = 'video'
          } else if (value.label === 'Template' || value.label === 'Document') {
            this.articleType.type = 'document'
          }
        } else {
          this.articleType.shown = false
          this.articleType.type = null
        }
      }
    },
    methods: {
      ...mapActions([
        'getTypes',
        'getCompanies',
        'getCategories',
        'getTags',
        'setInformationMsg',
        'getIndustries',
        'getCompanyLocations'
      ]),
      addVideoRow: function () {
        if (this.articleType.type === 'video') {
          this.entity.resources.video.push({
            videoUrl: '',
            videoTranscript: ''
          })
        } else {
          this.entity.resources.document.push({
            name: '',
            resource: null,
            extension: null,
            resourceUrl: '',
            resourceTranscript: ''
          })
        }
      },
      removeElement: function (index) {
        if (this.articleType.type === 'video') {
          this.entity.resources.video.splice(index, 1)
        } else {
          this.entity.resources.document.splice(index, 1)
        }
      },
      handleImageAdded: function (file, Editor, cursorLocation) {
        let reader = new FileReader()
        reader.readAsDataURL(file)
        let $this = this
        reader.onloadend = function () {
          $this.$prompt({
            'title': 'Image alt',
            'lbHide': true,
            'rbLabel': 'Ok'
          })
              .then(function (alt) {
                if (alt) {
                  Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '" alt="' + alt + '">')
                } else {
                  Editor.getModule('clipboard').dangerouslyPasteHTML(cursorLocation, '<img src="' + reader.result + '">')
                }
              })
        }
      },
      removeResource: function (index) {
        this.entity.resources.document[index].extension = null
        this.entity.resources.document[index].resource = null
        this.entity.resources.document[index].name = ''
      },
      addFormElement (type) {
        this.addElements[type] += 1
      },
      onThumbnailFileChange (e) {
        let self = this
        var input = document.getElementById('uploadThumbnail')
        if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif)$/i)) {
          this.isThumbnailFileUploaded = true
          var reader = new FileReader()
          reader.onload = function (e) {
            self.entity.featuredImage = e.target.result
          }
          reader.readAsDataURL(input.files[0])
        }
      },
      onResourceFileChange (value, i) {
        let self = this
        let valueTrimmed = value.target.value.replace(/^.*\\/, '')
        let input = document.getElementById('uploadResource_' + i)
        let extension = value.target.value.split('.').pop().toLowerCase()
        if (this.entity.type.label === 'Template' && ['doc', 'docx', 'xls', 'xlsx', 'pdf'].indexOf(extension) === -1) {
          alert('Only .doc, .docx, .xls, .xlsx or .pdf file extension allowed to add on article template type!')
          return
        }
        if (this.entity.type.label === 'Document' && extension !== 'pdf') {
          alert('Only .pdf file extension allowed to add on article document type!')
          return
        }
        if (input.files && input.files[0]) {
          let reader = new FileReader()
          reader.onload = function (e) {
            let fileName = input.files[0].name
            let extension = fileName.split('.').pop().toLowerCase()
            let fileNameArray = valueTrimmed.split('.')
            if (self.disableAPI) return
            let pageData = {
              name: fileNameArray[0],
              file: e.target.result,
              extension: extension,
              type: 'article'
            }
            self.disableAPI = true
            self.$http.post(api.URLS.uploadFile, pageData, api.headersAuthSettings).then((res) => {
              self.disableAPI = false
              if (Array.isArray(res.body)) {
                alert(res.body[0] + '. Please try again.')
                return
              }
              self.entity.resources.document[i].name = valueTrimmed
              self.entity.resources.document[i].extension = extension
              self.entity.resources.document[i].resource = res.body
            }).catch((err) => {
              self.disableAPI = false
              alert('Error on file upload. Please try again')
              console.log('err', err)
            })
          }
          reader.readAsDataURL(input.files[0])
        }
      },
      removeThumbnail () {
        var input = document.getElementById('uploadThumbnail')
        input.value = null
        this.isThumbnailFileUploaded = false
        this.entity.featuredImage = null
      },
      publishArticle (status, redirect) {
        this.$validator.validateAll()
        this.entity.loading = true
        this.$nextTick(() => {
          if (this.errors.items.length) {
            this.entity.loading = false
            return false
          }
          if (this.entity.loading === true) {
            this.entity.loading = false
            return false
          }
        })
        let self = this
        let editor = this.$refs.contentEditor
        this.entity.content = editor.getContent()
        let formData = {
          title: this.entity.title,
          imageFile: this.entity.featuredImage || '',
          alt: this.entity.altImage,
          content: this.entity.content,
          contentType: this.entity.type.value,
          status: status,
          isArticle: 1,
          children: this.entity.ttc.concat(this.entity.ttd),
          categories: Array.isArray(this.entity.category) ? this.entity.category : [this.entity.category],
          tags: this.entity.topic,
          companies: this.entity.company,
          industries: this.entity.industry,
          locations: this.entity.location,
          notCompanies: this.entity.notCompany,
          notIndustries: this.entity.notIndustry,
          notLocations: this.entity.notLocation
        }
        if (this.articleType.type === 'video') {
          formData.typeValues = []
          this.entity.resources.video.forEach((row, i) => {
            formData.typeValues.push({
              link: row.videoUrl,
              textarea: row.videoTranscript
            })
          })
        }
        if (this.articleType.type === 'document') {
          formData.typeValues = []
          this.entity.resources.document.forEach((row, i) => {
            formData.typeValues.push({
              link: row.resourceUrl,
              textarea: row.resourceTranscript,
              extension: row.extension,
              file: row.resource,
              name: row.name
            })
          })
        }
        let newWindow
        if (redirect) {
          newWindow = window.open('', '_blank')
        }
        this.$http.post(api.URLS.content, formData, api.headersAuthSettings)
          .then((res) => {
            self.infMsgTitle = 'A new Resource called ' + res.body.title + ' was successfully created.'
            self.infMsgDescription = ''
            self.infMsgClass = 'success'
            self.setInformationMsg({
              isShown: true,
              title: self.infMsgTitle,
              text: self.infMsgDescription,
              className: self.infMsgClass
            })
            if (redirect) {
              let props = this.$router.resolve({
                name: 'content',
                params: {id: res.body.id}
              })
              newWindow.location = props.href
              this.entity.loading = false
            }
            self.switchEditPage(res.body.id)
            // this.entity.loading = false
          })
          .catch((err) => {
            self.serverValidation.errors = err
            self.infMsgTitle = 'Error. We were not able to create this Resource because '
            self.infMsgTitle += (err.body.message).toLowerCase()
            self.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.'
            self.infMsgClass = 'error'
            self.setInformationMsg({
              isShown: true,
              title: self.infMsgTitle,
              text: self.infMsgDescription,
              className: self.infMsgClass
            })
          })
      },
      switchEditPage (id) {
        let props = this.$router.resolve({
          name: 'edit-article',
          params: {id: id}
        })
        location.href = props.href
      },
      goToAllArticles () {
        let props = this.$router.resolve({
          name: 'articles-list'
        })
        this.$router.push(props.href)
      },
      getOptionsThingsToConsider (search, loading) {
        loading(true)
        let urlString = `${api.URLS.search}&search=${search}&isArticle=true`
        this.$http.get(urlString, api.headersAuthSettings)
            .then((res) => {
              console.log(res)
              let items = res.body.data.items ? res.body.data.items : []
              this.thingsToConsiderOptions = items.map(item => {
                let industries = item.industries.map(item2 => {
                  return item2.name
                })
                industries = industries.length ? ' (' + industries.join(', ') + ')' : ''
                return {
                  value: item.id,
                  label: item.title + industries
                }
              })
              loading(false)
            })
            .catch((err) => {
              console.log(err)
              loading(false)
            })
      },
      getOptionsThingsToDo (search, loading) {
        loading(true)
        let urlString = `${api.URLS.search}&search=${search}&isArticle=false`
        this.$http.get(urlString, api.headersAuthSettings)
            .then((res) => {
              console.log(res)
              let items = res.body.data.items ? res.body.data.items : []
              this.thingsToDoOptions = items.map(item => {
                let industries = item.industries.map(item2 => {
                  return item2.name
                })
                industries = industries.length ? ' (' + industries.join(', ') + ')' : ''
                return {
                  value: item.id,
                  label: item.title + industries
                }
              })
              loading(false)
            })
            .catch((err) => {
              console.log(err)
              loading(false)
            })
      },
      handleScroll (event) {
        const headerPlaceholder = document.getElementById('headerPlaceholder')
        const header = document.querySelector('.article__header')
        if (!headerPlaceholder || !header) {
          return
        }
        const rect = headerPlaceholder.getBoundingClientRect()
        const sticky = rect.top
        if (sticky <= 0) {
          header.classList.add('sticky')
          headerPlaceholder.style.height = header.offsetHeight + 'px'
        } else {
          header.classList.remove('sticky')
          headerPlaceholder.style.height = ''
        }
      }
    },
    components: {},
    mounted () {
      this.getTypes()
      this.getTags()
      this.getCategories()
      this.getCompanies()
      this.getIndustries()
      this.getCompanyLocations()
    },
    created () {
      document.title = 'Create new Thing to Consider | Clear Assured'
      window.addEventListener('scroll', this.handleScroll)
      if (window.ga) {
        window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
        window.ga('send', 'pageview', {
          'page': location.pathname,
          'location': location.href,
          'title': document.title
        })
      }
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style src='@/assets/scss/components/article.scss' lang='scss' scoped />



// WEBPACK FOOTER //
// AddArticle.vue?468909f0